
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/share",
      function () {
        return require("private-next-pages/features/share.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/share"])
      });
    }
  